import React from 'react';
import PropTypes from 'prop-types';
import { Switch, Redirect } from 'react-router-dom';
import { DashboardRoute } from '@saucelabs/sl-container-dashboard';
import { BundleRoute } from '@saucelabs/sl-component-router';
import { LoginRequiredContainer } from '@saucelabs/sl-container-authentication';


import WebTestingContainer from './containers/configurator/WebTestingContainer';
import AppTestingContainer from './containers/configurator/AppTestingContainer';

const testProxyImport = () => import(/* webpackChunkName: "manual-test" */ './containers/sessionVirtual/TestProxyContainer');
const mobileImport = () => import(/* webpackChunkName: "manual-mobile" */ './components/MobileManualSession');
const desktopImport = () => import(/* webpackChunkName: "manual-desktop" */ './containers/sessionVirtual/DesktopManualContainer');

const ManualRoutes = ({ match }) => (
  <LoginRequiredContainer>
    <Switch>
      <BundleRoute
        load={testProxyImport}
        path={`${match.url}/test_proxy/:jobId`}
      />
      <BundleRoute
        load={mobileImport}
        path={`${match.url}/mobile/dataCenters/:dataCenterId/devices/:deviceId`}
      />
      <DashboardRoute
        component={WebTestingContainer}
        path={`${match.url}/web-testing`}
        viewName="Live Web Testing"
      />
      <DashboardRoute
        component={AppTestingContainer}
        path={`${match.url}/app-testing`}
        viewName="Live App Testing"
      />
      <BundleRoute
        load={desktopImport}
        path={`${match.url}/:taskId`}
      />
      <Redirect to="/live/web-testing" />
    </Switch>
  </LoginRequiredContainer>
);

ManualRoutes.propTypes = {
  match: PropTypes.object.isRequired,
};

export default ManualRoutes;
